import React from 'react'
import { observer } from 'mobx-react-lite';
import inputTypeStore from '../input-file/input-type';
import InputFileCard from '../input-file/InputFileCard';
import { HelpOther } from '@/common/helper';
import appLogger from '@public/log/monitor';

import { SVGPureIcon } from '@/ui';
import './index.scss'

import { Swiper, SwiperSlide } from 'swiper/react'
import KnowledgeCard from '../input-file/KnowledgeCard';
import { MAX_KNOWLEDGE_DISPLAY_COUNT } from '../input-file/shared';

function MultiFile(props) {
  const {handleSend, scene = "home", supportKnowledge} = props
  const fileList = Array.from(inputTypeStore.tempFile)

  /** 是否复数 */
  const isMulti = React.useMemo(() => fileList.length > 1, [fileList])

  return (
    <div className='multiFile-custom'>
      <Swiper
        className="w-full !overflow-visible mb-[16px]"
        direction="horizontal"
        slidesPerView={'auto'}
        spaceBetween={8}
        navigation={{
          prevEl: '.swiper-btn-prev',
          nextEl: '.swiper-btn-next'
        }}
      >
        {
          fileList && fileList.length > 1 ?  fileList.map(file => {
            return (
              <SwiperSlide key={file.name} className='!w-auto'>
                <InputFileCard
                  isMulti={isMulti}
                  file={file}
                  supportKnowledge={supportKnowledge}
                  onButtonClick={(type, prompt)=>{
                    handleSend(prompt, type);
                  }}
                  onClose={inputTypeStore.close}
                  onUploaded={detail => {
                    inputTypeStore.updateTempData("tempUploaded", detail, !!supportKnowledge)
                  }}
                  onError={
                    error => {
                      HelpOther.toast(error.message, 'error');
                      inputTypeStore.reset();
                      appLogger.log({
                        key: "aibot_plugin_public",
                        seg: "object",
                        action: "act",
                        arrt: "upload_file_fail",
                        doc_id: String(Math.floor(Math.random()*1000000000000000)),
                        doc_name: file.name,
                        ext: file.name?.split(".")?.[1] || "",
                        ext1: String((file.size / (1024 * 1024)).toFixed(5)),
                        ext2: error.message || "上传失败",
                        spage: `aibot_${scene}_uploadfile`
                      });
                    }
                  }
                  />
              </SwiperSlide>
            )
          }) :
          fileList.map(file => {
            if(file.dataset_info){
              return (
                <>
                  {
                    Object.keys(file.dataset_info).slice(0, MAX_KNOWLEDGE_DISPLAY_COUNT).map(id => {
                      const info = file.dataset_info[id];
                      return (
                        <SwiperSlide key={info.folder_id} className='!w-[172px] !mr-[8px]'>
                          <KnowledgeCard
                            info={info}
                            onClose={inputTypeStore.close}
                            closeable
                            />
                        </SwiperSlide>
                      )
                    })
                  }
                  {
                    Object.keys(file.dataset_info).length > MAX_KNOWLEDGE_DISPLAY_COUNT
                    ? (
                      <SwiperSlide key="more" className='!w-[172px] !mr-[8px]'>
                        <KnowledgeCard key="more" count={Object.keys(file.dataset_info).length - MAX_KNOWLEDGE_DISPLAY_COUNT} />
                      </SwiperSlide>
                    )
                    : null
                  }
                </>
              )
            }
            return (
              <InputFileCard
                key={file.name}
                file={file}
                supportKnowledge={
                  supportKnowledge
                }
                onButtonClick={(type, prompt)=>{
                  handleSend(prompt, type);
                }}
                onClose={inputTypeStore.reset}
                onUploaded={detail => {
                  inputTypeStore.updateTempData("tempUploaded", detail, !!supportKnowledge)
                }}
                onError={
                  error => {
                    HelpOther.toast(error.message, 'error');
                    inputTypeStore.reset();
                    appLogger.log({
                      key: "aibot_plugin_public",
                      seg: "object",
                      action: "act",
                      arrt: "upload_file_fail",
                      doc_id: String(Math.floor(Math.random()*1000000000000000)),
                      doc_name: file.name,
                      ext: file.name?.split(".")?.[1] || "",
                      ext1: String((file.size / (1024 * 1024)).toFixed(5)),
                      ext2: error.message || "上传失败",
                      spage: `aibot_${scene}_uploadfile`
                    });
                  }
                }
              />
            )
          })
        }
        <div className='swiper-btn-prev flex items-center justify-start'>
          <div className='swiper-btn-circle'>
            <SVGPureIcon name='swiper-left-arrow' className={'w-[16px] h-[16px]'} color="#000" />
          </div>
        </div>
        <div className='swiper-btn-next flex items-center justify-end'>
          <div className='swiper-btn-circle w-[24px] h-[24px] rounded-full bg-[#F5F5F5] flex items-center justify-center'>
            <SVGPureIcon name='swiper-right-arrow' className={'w-[16px] h-[16px]'} color="#000"/>
          </div>
        </div>

      </Swiper>
    </div>
  )
}

export default observer(MultiFile)
